import { render, staticRenderFns } from "./SingleItemContentProperties.vue?vue&type=template&id=917a234a&scoped=true&"
import script from "./SingleItemContentProperties.vue?vue&type=script&lang=js&"
export * from "./SingleItemContentProperties.vue?vue&type=script&lang=js&"
import style0 from "./SingleItemContentProperties.vue?vue&type=style&index=0&id=917a234a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917a234a",
  null
  
)

export default component.exports